import { isValid, parse, startOfMonth } from 'date-fns';

const MONTH_REFERENCE_DATE = new Date(2000, 0, 1);

export const formatDateInput = (input: string): Date | null => {
  if (!input) return null;

  const trimmed = input.trim();

  const formats = [
    { pattern: /^\d{8}$/, format: 'ddMMyyyy' },
    { pattern: /^\d{2}\/\d{2}\/\d{4}$/, format: 'dd/MM/yyyy' },
  ];

  for (const { pattern, format } of formats) {
    if (pattern.test(trimmed)) {
      const date = parse(trimmed, format, new Date());
      if (isValid(date)) {
        return date;
      }
      return null;
    }
  }

  return null;
};

export const formatMonthInput = (input: string): Date | null => {
  if (!input) return null;

  const trimmed = input.trim();

  const formats = [
    { pattern: /^\d{6}$/, format: 'MMyyyy' },
    { pattern: /^\d{2}\/\d{4}$/, format: 'MM/yyyy' },
  ];

  for (const { pattern, format } of formats) {
    if (pattern.test(trimmed)) {
      const date = parse(trimmed, format, MONTH_REFERENCE_DATE);
      if (isValid(date)) {
        return startOfMonth(date);
      }
      return null;
    }
  }

  return null;
};
